import React from "react";
import {
  PromptInput,
  PromptInputToolbar,
  PromptInputTools
} from "@v2/components/ui/ai/prompt";
import { ArrowUp } from "lucide-react";
import { cn } from "@gettactic/helpers";
import { MentionTextarea } from "@v2/components/form/MentionTextarea/MentionTextarea";
import {
  Category,
  ContentBlock
} from "@v2/components/form/MentionTextarea/types";

export interface ChatBotPromptInputProps {
  status?: string;
  handleSubmit: (bubbleText: string, aiText: string) => void;
  className?: string;
  showSuggestions?: boolean;
  placeholder?: string;
  isCompact?: boolean;
  inputSuggestions?: Category[];
  initialValue?: ContentBlock[];
}

const suggestions = [
  "Book a desk",
  "Report a problem",
  "Invite a visitor",
  "Schedule a catered lunch"
];

export const ChatBotPromptInput: React.FC<ChatBotPromptInputProps> = ({
  status,
  handleSubmit,
  className,
  showSuggestions,
  placeholder = "Ask anything",
  isCompact = false,
  inputSuggestions,
  initialValue
}) => {
  const [text, setText] = React.useState<string>("");
  const [input, setInput] = React.useState<ContentBlock[]>([]);
  const [submitCount, setSubmitCount] = React.useState(0);

  const submitButton = (
    <button
      className={
        "flex items-center justify-center rounded-full bg-[#0F2449] p-2"
      }
    >
      <ArrowUp className={"size-4 text-white"} />
    </button>
  );

  const _handleSubmit = (chatBlocks: ContentBlock[]) => {
    const chatText = chatBlocks
      .map((block) => block.text || block.label)
      .join(" ");

    const aiText = chatBlocks
      .map((block) => block.id || block.text || block.label)
      .join(" ");

    handleSubmit(chatText, aiText);
    setText("");
    setInput([]);
    setSubmitCount((prevCount) => prevCount + 1);
  };

  return (
    <PromptInput
      onSubmit={(event) => {
        event.stopPropagation();
        event.preventDefault();

        _handleSubmit(input);
      }}
      key={submitCount}
      className={cn(className, isCompact && "relative")}
    >
      <div className={"w-full pr-10"}>
        <MentionTextarea
          suggestions={inputSuggestions || []}
          triggerChars={{ "@": "Users" }}
          value={input}
          onChange={setInput}
          onSubmit={_handleSubmit}
          initialValue={initialValue}
        />
      </div>
      {/*<PromptInputTextarea
        onChange={(e) => setText(e.target.value)}
        value={text}
        placeholder={placeholder}
        className={"bg-white"}
      />*/}
      {isCompact && (
        <div className={"absolute top-4 right-2"}>{submitButton}</div>
      )}
      {!isCompact && (
        <PromptInputToolbar
          className={cn(
            showSuggestions ? "bg-[#F0F4F7]" : "",
            isCompact ? "border-t-0" : ""
          )}
        >
          <PromptInputTools>
            <div className={"mx-2 flex gap-2 py-2"}>
              {showSuggestions &&
                suggestions.map((suggestion, suggestionIndex) => (
                  <button
                    className={
                      "rounded-4xl border-1 border-neutral-100 bg-white px-3 py-1.5"
                    }
                    key={suggestionIndex}
                    onClick={() => handleSubmit(suggestion, suggestion)}
                  >
                    {suggestion}
                  </button>
                ))}
            </div>
          </PromptInputTools>

          <div className={"mx-2"}>{submitButton}</div>
        </PromptInputToolbar>
      )}
    </PromptInput>
  );
};
